import React from "react";
import BaseIcon from "../../../../../components/svg_icons/BaseIcon";

const activities = [
    {
        icon: "userPlus",
        color: "#10b981",
        title: "Amit Patel joined Ahmedabad Office",
        time: "10 mins ago",
    },
    {
        icon: "briefcase",
        color: "#2563eb",
        title: "GST Department created",
        time: "35 mins ago",
    },
    {
        icon: "building",
        color: "#f59e0b",
        title: "Mumbai Office added 5 employees",
        time: "1 hour ago",
    },
    {
        icon: "checkCircle",
        color: "#8b5cf6",
        title: "Audit Department completed 24 tasks",
        time: "2 hours ago",
    },
    {
        icon: "shieldCheck",
        color: "#ef4444",
        title: "Manager role permissions updated",
        time: "Today",
    },
];

const RecentFirmActivity = () => {
    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "24px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                }}
            >
                <div>
                    <h2
                        style={{
                            margin: 0,
                            color: "#0f172a",
                        }}
                    >
                        Recent Firm Activity
                    </h2>

                    <p
                        style={{
                            marginTop: "6px",
                            color: "#64748b",
                            fontSize: "14px",
                        }}
                    >
                        Latest updates across your organization.
                    </p>
                </div>

                <button
                    style={{
                        padding: "8px 14px",
                        border: "1px solid #d1d5db",
                        borderRadius: "10px",
                        background: "#fff",
                        cursor: "pointer",
                    }}
                >
                    View All
                </button>
            </div>

            {activities.map((activity, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        padding: "14px 0",
                        borderBottom:
                            index !== activities.length - 1
                                ? "1px solid #f1f5f9"
                                : "none",
                    }}
                >
                    <div
                        style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "12px",
                            background: `${activity.color}20`,
                            color: activity.color,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <BaseIcon name={activity.icon} />
                    </div>

                    <div style={{ flex: 1 }}>
                        <div
                            style={{
                                fontWeight: 600,
                                color: "#0f172a",
                            }}
                        >
                            {activity.title}
                        </div>

                        <div
                            style={{
                                fontSize: "13px",
                                color: "#64748b",
                                marginTop: "4px",
                            }}
                        >
                            {activity.time}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RecentFirmActivity;
